'use client';

import { MessageCircle } from 'lucide-react';
import Script from 'next/script';
import React, { useState } from 'react';

import IconButton from '@/components/common/IconButton';

const BASE_URL = 'https://crm.rizerssoft.app';

export default function ChatwootWidget() {
  const [loaded, setLoaded] = useState(false);

  const onScriptLoaded = () => {
    if (!loaded) {
      window.chatwootSettings = {
        style: 'flat',
        hideMessageBubble: true,
      };

      window.chatwootSDK.run({
        websiteToken: 'JpQbLx8usuZkoAhaCQNfbnGr',
        baseUrl: BASE_URL,
      });

      setLoaded(true);
    }
  };

  return (
    <>
      <Script
        src={`${BASE_URL}/packs/js/sdk.js`}
        strategy="lazyOnload"
        onLoad={onScriptLoaded}
      />
      {loaded && (
        <IconButton
          icon={<MessageCircle className="fill-white" />}
          className="circle-button-shinny button-ping !size-12 rounded-full !p-0 transition-all duration-500"
          type="button"
          onClick={() => window.$chatwoot.toggle()}
          aria-label="Chat with support"
        />
      )}
    </>
  );
}
